import axios from 'axios'
import modalEvent from './modal-event'
import router from '../router'
import { getHandledError } from './error-utils'
import { EventBus } from '../lib/event-bus'

let timestamp = null

try {
  timestamp = require('../../build-timestamp')
} catch (err) {
  // pass
}

const isProduction = process.env.NODE_ENV === 'production'
const baseUrl = isProduction ? '/api' : process.env.VUE_APP_API_BASE_URL

const httpClient = axios.create({
  baseURL: baseUrl,
  withCredentials: true
})

if (timestamp) {
  httpClient.defaults.params = {
    v: timestamp
  }
}

httpClient.interceptors.request.use(config => {
  if (config.url.indexOf('/temp-report/main/') !== 0) {
    EventBus.$emit('onApiLoading', `${config.method} ${config.url.replace(baseUrl, '')}`, 0)
    setTimeout(() => {
      EventBus.$emit('onApiLoading', config.method + ' ' + config.url.replace(baseUrl, ''), 1)
    }, 500)
  }
  return config
}, (err) => {
  return Promise.reject(err)
})

httpClient.interceptors.response.use(response => {
  EventBus.$emit('onApiLoading', `${response.config.method} ${response.config.url.replace(baseUrl, '')}`, -1)
  return response
}, (err) => {
  console.log(err)

  let isHandled = false

  if (err.response) {
    EventBus.$emit('onApiLoading', `${err.response.config.method} ${err.response.config.url.replace(baseUrl, '')}`, -1)

    const status = err.response.status

    switch (status) {
      case 503:
        router.push({ name: 'AppMaintenance' })
        isHandled = true
        break
      case 500:
        const errorMessage = err.response.data.message || ''
        modalEvent.openError({
          message: `Server error. ${errorMessage}`,
          action: 'noOp'
        })
        isHandled = true
        break
      case 422:
        err.name = 'ValidationError'
        break
      case 403:
        modalEvent.openError({
          message: 'Session state is changed, click confirm to refresh',
          action: 'noOp'
        }).then(() => {
          window.location.reload(true)
        })
        isHandled = true
        break
      case 409:
        modalEvent.openError({
          message: 'App is updated, click confirm to refresh',
          action: 'noOp'
        }).then(() => {
          window.location.reload(true)
        })
        isHandled = true
        break
    }
  }
  if (isHandled) {
    return Promise.reject(getHandledError())
  }

  return Promise.reject(err)
})

export function apiImageUrl (url) {
  if (url && url.charAt(0) === '/') {
    return `${baseUrl}${url}`
  }
  return url
}

export default httpClient



// WEBPACK FOOTER //
// ./src/lib/http-client.js